import { doLogin } from '@/api/api'
import { clearAuthStorage, getToken, getUserInfo, setToken, setUserInfo } from '@/utils/auth'

const state = {
  token: getToken() || '',
  userInfo: getUserInfo() || null
}

const mutations = {
  SET_TOKEN (state, token) {
    state.token = token || ''
  },
  SET_USER_INFO (state, userInfo) {
    state.userInfo = userInfo || null
  }
}

const actions = {
  // 登录：后端返回的用户信息中 aesUser 为后续请求的鉴权凭证
  async login ({ commit, dispatch }, form) {
    const res = await doLogin(form)
    const userInfo = res.data || {}
    const token = userInfo.aesUser || ''
    setToken(token)
    setUserInfo(userInfo)
    commit('SET_TOKEN', token)
    commit('SET_USER_INFO', userInfo)
    // 登录成功后立即按岗位生成菜单（避免守卫因已有 userInfo 而跳过 generateMenu）
    dispatch('permission/generateMenu', userInfo, { root: true })
    return userInfo
  },
  // 选择项目后重新登录（带 projectId），换取该项目的鉴权凭证
  async selectProject ({ commit, dispatch }, { zauPhone, zauPw, projectId }) {
    const res = await doLogin({ zauPhone, zauPw, projectId })
    const userInfo = res.data || {}
    const token = userInfo.aesUser || ''
    setToken(token)
    setUserInfo(userInfo)
    commit('SET_TOKEN', token)
    commit('SET_USER_INFO', userInfo)
    // 切换项目后同样按岗位重新生成菜单
    dispatch('permission/generateMenu', userInfo, { root: true })
    return userInfo
  },
  // 后端无专门的刷新接口，直接使用本地缓存的用户信息恢复登录态
  refreshUserInfo ({ commit, state }) {
    if (!state.token) return null
    const cached = getUserInfo() || {}
    commit('SET_USER_INFO', cached)
    return cached
  },
  logout ({ commit }) {
    clearAuthStorage()
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', null)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
